<template>
  <div class="about-page">
    <AboutHero />
    <AboutBio />
    <AboutMission />
  </div>
</template>

<script setup>
import AboutHero from '@/components/AboutHero.vue';
import AboutBio from '@/components/AboutBio.vue';
import AboutMission from '@/components/AboutMission.vue';
</script>

<style scoped>
.about-page {
  overflow-x: hidden;
}
</style>
